module.exports = __webpack_public_path__ + "static/NY-StandardOperatingProcedures-61ac500500a8e52ab584073f07ca7f06.pdf";